var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrepare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10070",
    "data-name": "Group 10070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.638,
    height: 28.118,
    viewBox: "0 0 22.638 28.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4830",
    "data-name": "Rectangle 4830",
    width: 22.638,
    height: 28.118,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10069",
    "data-name": "Group 10069",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M19.706,27.736H2.9a3.438,3.438,0,0,1-2.9-3.245L0,5.56A3.349,3.349,0,0,1,3.288,2.235l2.471-.007,0,1.571A2.649,2.649,0,0,0,8.4,6.485l5.871,0a2.614,2.614,0,0,0,2.609-2.628V2.227l2.493.009a3.346,3.346,0,0,1,3.268,3.325V24.426a3.433,3.433,0,0,1-2.931,3.31M3.7,11.925l.819.8a.851.851,0,0,0,1.174-.055l1.966-1.981A.817.817,0,0,0,6.476,9.565l-1.408,1.4-.252-.24a.831.831,0,0,0-1.191.019A.844.844,0,0,0,3.7,11.925m14.689.035a.825.825,0,0,0-.056-1.647H9.608a.82.82,0,0,0-.034,1.639ZM3.594,17.682l.837.844a.859.859,0,0,0,1.2.022l2-2a.816.816,0,0,0-1.177-1.128l-1.4,1.389a.715.715,0,0,1-.209-.185.829.829,0,0,0-1.172-.1.8.8,0,0,0-.083,1.162m14.761.116a.8.8,0,0,0,.771-.849.812.812,0,0,0-.8-.785H9.563a.822.822,0,0,0,.045,1.644ZM3.762,23.529l.77.77A.887.887,0,0,0,5.8,24.31l1.939-1.952A.817.817,0,0,0,6.581,21.2L5.172,22.595a.793.793,0,0,1-.194-.173.824.824,0,1,0-1.216,1.107M18.45,23.6a.82.82,0,0,0-.011-1.64H9.718a.82.82,0,0,0-.033,1.64Z",
    transform: "translate(0 0.382)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M13.538,5.217l-6.554.007a.633.633,0,0,1-.656-.606L6.321,1.98a.635.635,0,0,1,.6-.664l1.455-.021A2.017,2.017,0,0,1,10.2,0a1.988,1.988,0,0,1,1.886,1.288l1.439.023a.638.638,0,0,1,.623.627V4.607a.621.621,0,0,1-.6.61",
    transform: "translate(1.085 0)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepare);
export default __webpack_public_path__ + "static/media/prepare.c445117fb818731a1730f93263607bd3.svg";
export { ForwardRef as ReactComponent };